<apx-chart
  [chart]="chart"
  [dataLabels]="dataLabels"
  [labels]="labels"
  [series]="series"
  [stroke]="stroke"
  [forecastDataPoints]="forecastDataPoints"
  [yaxis]="yAxisConfig ? yAxisConfig : yaxis"
></apx-chart>
